import React, { useState } from 'react';
import { toast } from 'sonner';
import { Lock, ShieldCheck, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { overrideScoutScan, apiError } from '../../services/scoutApi';

export const OverridePanel = ({ scan, canManage, onSaved }) => {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const o = scan.override;

  if (o) {
    return (
      <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/5 p-4 flex items-start gap-3" data-testid="scout-override-record">
        <ShieldCheck className="h-5 w-5 text-emerald-600 mt-0.5 shrink-0" />
        <div className="text-sm">
          <p className="font-semibold">Verified by {o.by} · {new Date(o.at).toLocaleString()}</p>
          <p className="text-muted-foreground mt-0.5">“{o.reason}”</p>
        </div>
      </div>
    );
  }
  if (!canManage || scan.status !== 'completed') return null;
  const blocked = scan.verdict === 'high_risk' && scan.candidate_id;

  const save = async () => {
    setBusy(true);
    try { await overrideScoutScan(scan.id, reason); toast.success('Override recorded in the audit log'); setReason(''); onSaved?.(); } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className={`rounded-2xl border p-4 space-y-3 ${blocked ? 'border-red-500/30 bg-red-500/5' : 'bg-card'}`} data-testid="scout-override-panel">
      <div className="flex items-start gap-3">
        <Lock className={`h-5 w-5 mt-0.5 shrink-0 ${blocked ? 'text-red-600' : 'text-muted-foreground'}`} />
        <div>
          <p className="text-sm font-semibold">{blocked ? 'Gateway: interview links and emails are blocked' : 'Mark as verified'}</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            {blocked ? 'Verify the signals below, then record why it is safe to continue. The reason is saved to the audit log.'
              : 'Checked the signals yourself? Record what you verified — it is saved to the audit log.'}
          </p>
        </div>
      </div>
      <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2} placeholder="e.g. Verified identity on a camera-on call; ID matches name and photo"
        data-testid="scout-override-reason" />
      <div className="flex justify-end">
        <Button size="sm" variant={blocked ? 'destructive' : 'outline'} disabled={reason.trim().length < 10 || busy} onClick={save} className="gap-2" data-testid="scout-override-submit">
          {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />} {blocked ? 'Override and unblock' : 'Mark as verified'}
        </Button>
      </div>
    </div>
  );
};

export default OverridePanel;
